import { render, staticRenderFns } from "./IssueHistory.vue?vue&type=template&id=f2311a4a&"
import script from "./IssueHistory.vue?vue&type=script&lang=js&"
export * from "./IssueHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports